// @flow

import React from 'react';
import { defaultIconProps, type IconProps, IconSvgWrapper } from './base';

const CheckmarkIcon = (props: IconProps) => (
  <IconSvgWrapper {...props}>
    <path
      fill={props.color}
      d="M9.37679 18.8124C9.18276 18.8126 8.99648 18.7363 8.85839 18.6L3.62879 13.464C3.5553 13.397 3.49607 13.3159 3.45465 13.2256C3.41323 13.1352 3.39047 13.0374 3.38773 12.938C3.38499 12.8386 3.40234 12.7397 3.43872 12.6471C3.4751 12.5546 3.52978 12.4704 3.59947 12.3994C3.66917 12.3285 3.75246 12.2724 3.84435 12.2344C3.93624 12.1965 4.03484 12.1774 4.13426 12.1785C4.23369 12.1795 4.33188 12.2006 4.42297 12.2404C4.51406 12.2803 4.59617 12.3381 4.66439 12.4104L8.94719 16.6104C9.05935 16.7204 9.21014 16.7819 9.36719 16.7819C9.52424 16.7819 9.67503 16.7204 9.78719 16.6104L19.4256 6.96002C19.5649 6.82554 19.7514 6.75111 19.9451 6.75271C20.1387 6.75431 20.324 6.83183 20.461 6.96859C20.5981 7.10535 20.6761 7.29044 20.6781 7.48407C20.6801 7.67769 20.6061 7.86438 20.472 8.00401L9.89879 18.6C9.83009 18.6681 9.7486 18.7219 9.65901 18.7584C9.56942 18.7948 9.47351 18.8132 9.37679 18.8124Z"
    />
  </IconSvgWrapper>
);

CheckmarkIcon.defaultProps = defaultIconProps;

export default CheckmarkIcon;
